<template>
  <main class="sa-content">
      <div class="sa-card-large">
        <add-medicine />
      </div>
  </main>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
import AddMedicineVue from '../../../../components/appointments/diagnosis/prescription/AddMedicine.vue';
export default {
  components: {
    'add-medicine': AddMedicineVue,
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
  }
};
</script>
